(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ldp-pass-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    (function initKefoffCarousel() {
      var carousels = document.querySelectorAll('.kefoff-carousel');
      carousels.forEach(function (carousel) {
        var track = carousel.querySelector('.kc-track');
        var slides = carousel.querySelectorAll('.kc-slide');
        var prev = carousel.querySelector('.kc-arrow--prev');
        var next = carousel.querySelector('.kc-arrow--next');
        var dotsWrap = carousel.querySelector('.kc-progress');
        var autoplay = carousel.dataset.autoplay === 'true';
        var speed = parseInt(carousel.dataset.speed || 4000, 10);
        var index = 0;

        // Build progress segments (pages)
        function getSlidesPerView() {
          var w = window.innerWidth;
          if (w <= 640) return 1;
          if (w <= 1024) return 2;
          return 4;
        }

        function buildProgress() {
          if (!dotsWrap) return;
          dotsWrap.innerHTML = '';
          var spv = getSlidesPerView();
          var pages = Math.ceil(slides.length / spv) || 1;
          for (var p = 0; p < pages; p++) {
            var s = document.createElement('button');
            s.className = 'kc-seg';
            s.dataset.page = p;
            dotsWrap.appendChild(s);
          }
          dotsWrap.addEventListener('click', function (e) {
            if (e.target && e.target.classList.contains('kc-seg')) {
              goTo(parseInt(e.target.dataset.page, 10) * getSlidesPerView());
            }
          });
        }

        function updateProgress() {
          if (!dotsWrap) return;
          var segs = dotsWrap.querySelectorAll('.kc-seg');
          segs.forEach(function (s) {
            s.classList.remove('is-active');
          });
          var spv = getSlidesPerView();
          var pageIndex = Math.round(index / spv);
          if (segs[pageIndex]) segs[pageIndex].classList.add('is-active');
        }

        function slideTo(i) {
          var spv = getSlidesPerView();
          if (i < 0) i = 0;
          if (i > slides.length - spv) i = Math.max(0, slides.length - spv);
          index = i;
          var slideWidth = slides[0].getBoundingClientRect().width + 24; // gap
          var offset = slideWidth * index;
          track.style.transform = 'translateX(' + -offset + 'px)';
          updateProgress();
        }

        function goTo(i) {
          slideTo(i);
        }

        if (prev)
          prev.addEventListener('click', function () {
            goTo(index - 1);
          });
        if (next)
          next.addEventListener('click', function () {
            goTo(index + 1);
          });

        // Drag support (pointer events)
        var isDown = false,
          startX,
          scrollLeft,
          startTransform;
        carousel.querySelector('.kc-track-wrapper').addEventListener('pointerdown', function (e) {
          isDown = true;
          carousel.classList.add('is-dragging');
          startX = e.clientX;
          startTransform = getTranslateX(track);
          track.style.transition = 'none';
          e.target.setPointerCapture && e.target.setPointerCapture(e.pointerId);
        });
        window.addEventListener('pointermove', function (e) {
          if (!isDown) return;
          var dx = e.clientX - startX;
          track.style.transform = 'translateX(' + (startTransform + dx) + 'px)';
        });
        window.addEventListener('pointerup', function (e) {
          if (!isDown) return;
          isDown = false;
          carousel.classList.remove('is-dragging');
          track.style.transition = ''; // snap to nearest
          var curX = -getTranslateX(track);
          var slideW = slides[0].getBoundingClientRect().width + 24;
          var newIndex = Math.round(curX / slideW);
          slideTo(newIndex);
        });

        function getTranslateX(el) {
          var st = window.getComputedStyle(el);
          var tr = st.transform || st.webkitTransform;
          if (tr && tr !== 'none') {
            var match = tr.match(/matrix\((.+)\)/);
            if (match) {
              var values = match[1].split(', ');
              return parseFloat(values[4]);
            }
          }
          return 0;
        }

        // Autoplay
        var autoplayId = null;
        if (autoplay) {
          autoplayId = setInterval(function () {
            var nextIndex = index + 1;
            if (nextIndex >= slides.length) nextIndex = 0;
            goTo(nextIndex);
          }, speed);
          carousel.addEventListener('mouseenter', function () {
            if (autoplayId) clearInterval(autoplayId);
          });
          carousel.addEventListener('mouseleave', function () {
            if (autoplay) {
              autoplayId = setInterval(function () {
                var nextIndex = index + 1;
                if (nextIndex >= slides.length) nextIndex = 0;
                goTo(nextIndex);
              }, speed);
            }
          });
        }

        // init
        buildProgress();
        slideTo(0);
        updateProgress();
        // resize: rebuild progress and ensure slide fits
        var resizeTimeout = null;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function () {
            buildProgress();
            slideTo(index);
            updateProgress();
          }, 120);
        });
      });
    })();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ldp-pass-refer-friend"] && !Shopify.designMode) return;
  try {
    
  /* No JS needed for this static hero section */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ldp-spaces-carousel-space"] && !Shopify.designMode) return;
  try {
    
  class SpaceCarousel {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.space-slide');
      this.buttons = container.querySelectorAll('.space-button');
      this.progressBars = container.querySelectorAll('.progress-bar');
      this.autoplayDelay = 5000; // 5 seconds per slide
      this.currentIndex = 0;
      this.autoplayTimer = null;

      this.init();
    }

    init() {
      // Show first slide
      this.showSlide(0);

      // Add click handlers
      this.buttons[0].addEventListener('click', () => this.prev());
      this.buttons[1].addEventListener('click', () => this.next());

      // Start autoplay
      this.startAutoplay();

      // Pause on hover
      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => this.startAutoplay());
    }

    showSlide(index) {
      // Remove active class from current
      this.slides[this.currentIndex].classList.remove('is-active');
      this.progressBars[this.currentIndex].classList.remove('is-active');

      // Update index
      this.currentIndex = index;

      // Add active class to new
      this.slides[this.currentIndex].classList.add('is-active');
      this.progressBars[this.currentIndex].classList.add('is-active');
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.showSlide(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.showSlide(prevIndex);
    }

    startAutoplay() {
      this.autoplayTimer = setInterval(() => this.next(), this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  // Initialize all carousels on page
  document.querySelectorAll('.space-carousel').forEach((carousel) => {
    new SpaceCarousel(carousel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-hero"] && !Shopify.designMode) return;
  try {
    
  /* No JS needed for this static hero section */

  } catch(e) { console.error(e); }
})();
})();
